module.exports = __webpack_public_path__ + "static/sub-services-2-6b23f94924cba263f3addc4a0f2139b2.jpg";